<template>
  <div class="home_jurusan">
    <div
      class="gdlr-core-pbf-wrapper "
      style="padding: 90px 0px 55px 0px;"
      data-skin="Column White"
    >
      <div
        class="gdlr-core-pbf-background-wrap"
        style="background-color: #1e1e1e ;"
      ></div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js ">
        <div
          class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container"
        >
          <div
            v-for="(jurusan, index) in majors.slice(0, 4)"
            :key="`jurusan_${index}`"
            data-aos="zoom-in"
            :data-aos-duration="index + `000`"
            :data-aos-delay="index + `00`"
            class="gdlr-core-pbf-column gdlr-core-column-15"
          >
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js ">
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js ">
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-column-service-item gdlr-core-item-pdb  gdlr-core-left-align gdlr-core-column-service-icon-top gdlr-core-no-caption gdlr-core-item-pdlr"
                    style="padding-bottom: 30px;"
                  >
                    <!-- <div
                      class="gdlr-core-column-service-media gdlr-core-media-image"
                      style="margin-bottom: 35px;"
                    >
                      <img
                        src="upload/col-icon-1.png"
                        alt=""
                        width="41"
                        height="41"
                        title="col-icon-1"
                      />
                    </div> -->
                    <div class="gdlr-core-column-service-content-wrapper">
                      <div class="gdlr-core-column-service-title-wrap">
                        <h3
                          class="gdlr-core-column-service-title gdlr-core-skin-title"
                          style="font-size: 21px ;font-weight: 700 ;text-transform: none ;"
                        >
                          {{ jurusan.title }}
                        </h3>
                      </div>
                      <div
                        class="gdlr-core-column-service-content"
                        style="font-size: 16px ;text-transform: none ;"
                        v-html="jurusan.body.slice(0, 150) + `...`"
                      ></div>
                      <router-link
                        class="gdlr-core-column-service-read-more gdlr-core-info-font"
                        :to="`/jurusan-detail/${jurusan.url}`"
                        style="font-style: normal ;margin-top: 0px ;"
                        >Selengkapnya</router-link
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "majors",
  props: ["majors"],
};
</script>
